/**
 * EU Funding Logos Component
 * Displays three EU funding program logos in a grid layout
 */
export function EuLogos() {
  return (
    <div className="mb-4 grid w-60 grid-cols-3 items-center gap-2 px-4">
      <img
        className="h-auto w-full object-contain"
        alt="Fundusze Europejskie"
        src="/images/eu/1.png"
      />
      <img
        className="h-auto w-full object-contain"
        alt="Rzeczypospolita Polska"
        src="/images/eu/2.png"
      />
      <img
        className="h-auto w-full object-contain"
        alt="Unia Europejska"
        src="/images/eu/3.png"
      />
    </div>
  );
}
